(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDiagnosisDeleteController',ProcedureDiagnosisDeleteController);

    ProcedureDiagnosisDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProcedureDiagnosis'];

    function ProcedureDiagnosisDeleteController($uibModalInstance, entity, ProcedureDiagnosis) {
        var vm = this;

        vm.procedureDiagnosis = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProcedureDiagnosis.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
